
export class HistoryEventDto {

  id: number;
  operation: string;
  description: string;
  args: string;
  dateEvent: Date;
  loginUser: string;

  static getAllGraphQlProperties() {
    return `
    id,
    operation,
    description,
    args,
    dateEvent,
    loginUser
    `
  }
}
